/* SÁRO shoppable video: model info pill ("@handle wears a size S and is 163cm tall").
   Reads the "model" details saved with each video and shows them while that video plays. */
(function () {
  'use strict';
  if (window.SVModelInfoLoaded) return;
  window.SVModelInfoLoaded = true;

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function findModel(src) {
    if (!src) return null;
    var lists = document.querySelectorAll('script[data-sv-data]');
    for (var i = 0; i < lists.length; i++) {
      var items;
      try { items = JSON.parse(lists[i].textContent); } catch (e) { continue; }
      for (var j = 0; j < items.length; j++) {
        if (items[j] && items[j].src === src) return items[j].model || null;
      }
    }
    return null;
  }

  function render(box, m) {
    if (!m || !m.size) { box.hidden = true; box.innerHTML = ''; return; }
    var who = m.handle
      ? '<a class="sv-player__model-link" href="https://www.instagram.com/' + encodeURIComponent(m.handle) + '/" target="_blank" rel="noopener noreferrer">@' + esc(m.handle) + '</a>'
      : 'Model';
    var text = who + ' wears a size ' + esc(m.size) + (m.height ? ' and is ' + esc(m.height) + ' tall' : '');
    box.innerHTML = '<span class="sv-player__model-pill">' + text + '</span>';
    box.hidden = false;
  }

  function init() {
    var player = document.getElementById('SVPlayer');
    if (!player) { setTimeout(init, 300); return; }
    var video = player.querySelector('.sv-player__video');
    var box = player.querySelector('[data-sv-model]');
    if (!video || !box) return;
    var update = function () { render(box, findModel(video.getAttribute('src'))); };
    video.addEventListener('loadstart', update);
    video.addEventListener('emptied', update);
    // Keep taps on the link from pausing or swiping the video
    box.addEventListener('click', function (e) { e.stopPropagation(); });
    box.addEventListener('touchend', function (e) { e.stopPropagation(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
